/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type LinkDetailsContainer_settings = {
    readonly organization: {
        readonly url: string;
    };
    readonly " $refType": "LinkDetailsContainer_settings";
};
export type LinkDetailsContainer_settings$data = LinkDetailsContainer_settings;
export type LinkDetailsContainer_settings$key = {
    readonly " $data"?: LinkDetailsContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"LinkDetailsContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "LinkDetailsContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = 'a1cbf837088c800e1dd001ba34c99537';
export default node;
